
import createIconComponent from '../utils/createIconComponent';
import { SVG_DISCOVER } from '../../../dist';
import React from 'react';
const DiscoverIcon = createIconComponent({ content: SVG_DISCOVER, height: 24, width: 36 });
DiscoverIcon.displayName = 'DiscoverIcon';
export default DiscoverIcon;
